import { useState } from "react";

import { NUMBER } from "../libs/utils";
import OTPInput from "react-otp-input";

const CustomOtp = ({ inputClass, otpInput, otpError, resendOtpError }) => {
  const [otp, setOtp] = useState("");

  const handleOtpChange = (value) => {
    if (NUMBER.test(Number(value))) {
      setOtp(value);
      otpInput(value);
    }
  };

  const handleKeyUp = (e) => {
    if (otp.length === 6) {
      e?.target?.blur();
    }
  };

  return (
    <>
      <div onKeyUp={handleKeyUp} className={`otpInputContainerClass`}>
        <OTPInput
          shouldAutoFocus={true}
          numInputs={6}
          value={otp}
          onChange={handleOtpChange}
          inputStyle={inputClass}
          className={`formGroupOtp`}
          renderInput={(props) => (
            <input {...props} type="number" inputMode="numeric" />
          )}
        />
      </div>

      <span className="errMsg">{otpError}</span>
      {resendOtpError && !otpError && (
        <span className="errMsg">{resendOtpError}</span>
      )}
    </>
  );
};
export default CustomOtp;
